import ClubLeaderBoardsPage from '../../../components/ClubLeaderBoardsPage/ClubLeaderBoards';

const ClubLeaderBoards = () => {
  return <ClubLeaderBoardsPage />;
}

export default ClubLeaderBoards;